import PropTypes from "prop-types";

export const _NavParentRevamp = {
  children: PropTypes.node,
};

export const NavParentRevampPropTypes = _NavParentRevamp;
